
import { Action, combineReducers } from '@ngrx/store';

import { IBackAuthState } from './auth.state';
import { BackAuthEntitiesReducers } from './entities/entities.reducer';
import { BackAuthEntitiesFeatureKey } from './entities/entities.state';
import { BackAuthUsersReducers } from './users/users.reducer';
import { BackAuthUsersFeatureKey } from './users/users.state';

export function BackAuthReducers (state: IBackAuthState | undefined, action: Action)
{
    return combineReducers({
        [BackAuthEntitiesFeatureKey]: BackAuthEntitiesReducers,
        [BackAuthUsersFeatureKey]: BackAuthUsersReducers
    })(state, action);
}

//     on(
//         fromBackAuthStoreActions.BackAuthUserSelectedSet,
//         (state, { user }) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 selected: {
//                     user
//                 }
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUserSelectedReset,
//         (state) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 selected: null
//             }
//         })
//     ),
//     // #endregion
//
//     on(
//         fromBackAuthStoreActions.BackAuthUserIdentityUpdated,
//         (state: IBackAuthState, { external: external, user: user }: { external: boolean, user: Update<User> }) =>
//         {
//             const st = {
//                 ...state
//             };

//             if (external)
//             {
//                 st.users.external.collection = usersAdapter.updateOne(user, state.users.external.collection);
//             }
//             else
//             {
//                 st.users.internal.collection = usersAdapter.updateOne(user, state.users.internal.collection);
//             }

//             return st;
//         }
//     ),

//     on(
//         fromBackAuthStoreActions.BackAuthEntitiesCleared,
//         (state: IBackAuthState, { external }) =>
//         {
//             const st = {
//                 ...state
//             };

//             if (external)
//             {
//                 st.entities.external.collection = entitiesAdapter.removeAll(state.entities.external.collection);
//             }
//             else
//             {
//                 st.entities.internal.collection = entitiesAdapter.removeAll(state.entities.internal.collection);
//             }

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUsersCleared,
//         (state: IBackAuthState, { external }) =>
//         {
//             const st = {
//                 ...state
//             };

//             if (external)
//             {
//                 st.users.external.collection = usersAdapter.removeAll(state.users.external.collection);
//             }
//             else
//             {
//                 st.users.internal.collection = usersAdapter.removeAll(state.users.internal.collection);
//             }

//             return st;
//         }
//     ),

// );
